import React, { createContext, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import { appInfo } from "../AppInfo";
import { truongApi } from "../api/truongApi";
import { initialUserInfo } from "../models/response/account/user-info";
import { pageBaseStatus } from "../state/pageBaseStatus";
import { RootState } from "../state/reducers";
import { truongActionTypes } from "../state/reducers/truongReducer";

export enum HttpMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE"
}

type CommonContextType = {
    children: React.ReactNode
}

type CommonStoreType = {
    getDataGridStorageKey: (key: string) => string,
    checkAccesiableTo: (path: string, httpMethod: HttpMethod | "GET" | "POST" | "PUT" | "DELETE") => boolean,
    checkAccesiableToV2: (path: string, httpMethod: HttpMethod | "GET" | "POST" | "PUT" | "DELETE") => boolean,
    canAccessTo: (path: string, httpMethod?: HttpMethod | "GET" | "POST" | "PUT" | "DELETE") => boolean,
    createUUID: () => string,
    translate: (code: string) => string
}

const CommonContext = createContext({} as CommonStoreType);
const useCommonContext = () => useContext(CommonContext)
const CommonProvider = ({ children }: CommonContextType) => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.auth.user_info) || initialUserInfo
    const truong: any = useSelector((state: RootState) => (state as any).truong)

    useEffect(() => {
        if (user && user.id && truong && truong.status === pageBaseStatus.is_not_initial) {
            (async () => {
                dispatch({ type: truongActionTypes.LOAD.START })
                const res: any = await (truongApi as any).SelectAll()
                if (res.is_success) dispatch({ type: truongActionTypes.LOAD.SUCESS, payload: res.data })
                else dispatch({ type: truongActionTypes.LOAD.ERROR, payload: res.message })
            })()
        }
    }, [user?.id])

    const store: CommonStoreType = {
        getDataGridStorageKey: (key: string) => {
            return `dataGridStorangeKey.${appInfo.versionDataGridStorageKey || ""}.${user.id}.${key}`
        },
        checkAccesiableTo: () => true,
        checkAccesiableToV2: () => true,
        canAccessTo: () => true,
        createUUID: () => uuidv4(),
        translate: (code: string) => code
    }
    return (
        <CommonContext.Provider value={store}>
            {children}
            <ToastContainer />
        </CommonContext.Provider>
    );
}
export {
    CommonProvider,
    useCommonContext
};